export default __webpack_public_path__ + "static/media/igor-piquet-modal.482a2b57.jpg";